<template>
    <div>
        <h1 class="text-h5 my-5">
            <router-link :to="{name: 'overview', params: {view: 'nodes'}, query: $api.contextQuery()}">Nodes</router-link> / {{name}}
            <v-progress-circular v-if="loading" indeterminate color="green" class="ml-3"/>
        </h1>

        <Dashboard v-if="node" :name="name" :widgets="node.widgets" class="mt-3" />
        <NoData v-else-if="!loading" />
    </div>
</template>

<script>
import Dashboard from "@coroot/coroot/src/components/Dashboard";
import NoData from "@coroot/coroot/src/components/NoData.vue";

export default {
    props: {
        projectId: String,
        name: String,
    },

    components: {Dashboard, NoData},

    data() {
        return {
            node: null,
            loading: false,
        };
    },

    mounted() {
        this.get();
        this.$events.watch(this, this.get, 'refresh');
    },

    methods: {
        get() {
            this.loading = true;
            this.$api.getNode(this.name, (data, meta) => {
                this.loading = false;
                this.node = data;
            });
        },
    },
};
</script>
